export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/identity.js
// module id = 1530
// module chunks = 6